import React from "react";
import { t } from "i18next";
import {
  filterarcade,
  filtercasion,
  filtercrash,
  filterfishing,
  filterlotto,
  filterslot,
  filtertable,
} from "./ListHome";

const CasinoSearch = ({
  setShow,
  active,
  activeInner,
  setActiveInner,
  setInput,
  input,
}) => {
  let object = {
    casino: filtercasion,
    slots: filterslot,
    table: filtertable,
    crash: filtercrash,
    fishing: filterfishing,
    arcade: filterarcade,
    lottery: filterlotto,
  };
  return (
    <div className="searchpage ng-tns-c2684251700-963 game-page-filter ng-star-inserted active-fide-in">
      <div className="search-top-info ng-tns-c2684251700-888">
        <div
          onClick={() => setShow(false)}
          className="back ng-tns-c2684251700-888"
          style={{
            maskImage: 'url("/assets/Icon/icon-arrow-type01.svg")',
          }}
        >
          {t("BackButton")}
        </div>
        <div
          className="cdk-visually-hidden cdk-focus-trap-anchor"
          aria-hidden="true"
        />
        <input
          onChange={(e) => setInput(e.target.value)}
          value={input}
          type="text"
          className="ng-tns-c2684251700-888 ng-untouched ng-pristine ng-valid ng-star-inserted"
          placeholder={t("SearchGames")}
        />
        <div
          className="cdk-visually-hidden cdk-focus-trap-anchor"
          aria-hidden="true"
        />
      </div>
      <div className="searchpage-main ng-tns-c2684251700-888">
        <div className="search-checkbox-group check-group ng-tns-c2684251700-888 ng-star-inserted">
          <h2 className="ng-tns-c2684251700-888 ng-star-inserted">
            {t("Providers")}
          </h2>

          <ul className="ng-tns-c2684251700-888">
            {object[active]?.map((res) => {
              return (
                <li
                  onClick={() => setActiveInner(res?.name)}
                  className="ng-tns-c2684251700-888 ng-star-inserted"
                >
                  <input
                    className="ng-tns-c2684251700-888"
                    type="checkbox"
                    checked={res?.name == activeInner}
                  />
                  <label className="ng-tns-c2684251700-888">
                    <span className="ng-tns-c2684251700-888">{res?.name}</span>
                    <i
                      className="ng-tns-c2684251700-888"
                      style={{
                        backgroundImage: 'url("/assets/Other/check.svg")',
                      }}
                    />
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <div
        onClick={() => setShow(false)}
        className="searchpage-bar ng-tns-c2684251700-888"
      >
        <div className="button btn-primary ng-tns-c2684251700-888">
          {t("Confirm")}
        </div>
      </div>
    </div>
  );
};

export default CasinoSearch;
